export default "__VITE_ASSET__CjRJyCvj__"